import { css } from '@emotion/core';
import { tokens } from '@domain-group/fe-brary';
var colors = tokens.colors;
var _ref = {
  name: "4g6ai3",
  styles: "cursor:pointer;"
};
export var card = _ref2 => {
  var hasOnClick = _ref2.hasOnClick;
  return /*#__PURE__*/css("background-color:", colors.neutral.subdued.default, ";border:1px solid ", colors.neutral.trim.default, ";border-radius:4px;", hasOnClick && _ref);
};
export var content = {
  name: "1ruxp1v",
  styles: "padding:20px;"
};
export var footer = /*#__PURE__*/css();
export var action = {
  name: "pkx0f0",
  styles: "text-align:left;padding:12px 20px 14px 20px;"
};